const FRONT_MATTER_DELIMITER_PATTERN = /^\s*-{3,}\s*$/;
const FRONT_MATTER_OPEN_PATTERN = /^---\s*$/;

const stripWrappingQuotes = (value) => {
  const trimmed = value.trim();
  const quote = trimmed[0];

  if (
    (quote === '"' || quote === "'") &&
    trimmed.endsWith(quote) &&
    trimmed.length >= 2
  ) {
    return trimmed.slice(1, -1).trim();
  }

  return trimmed;
};

const parseList = (value) => {
  const trimmed = value.trim();

  if (!trimmed) return [];

  if (trimmed.startsWith("[") && trimmed.endsWith("]")) {
    return trimmed
      .slice(1, -1)
      .split(",")
      .map(stripWrappingQuotes)
      .filter(Boolean);
  }

  return [stripWrappingQuotes(trimmed)].filter(Boolean);
};

const parseInteger = (value) => {
  const parsedValue = Number.parseInt(stripWrappingQuotes(value), 10);
  return Number.isFinite(parsedValue) && parsedValue > 0 ? parsedValue : null;
};

const parseFrontMatterBlock = (frontMatter) => {
  const metadata = {};

  frontMatter.split(/\n/).forEach((line) => {
    const trimmed = line.trim();

    if (!trimmed || trimmed.startsWith("#")) return;

    const separatorIndex = trimmed.indexOf(":");
    if (separatorIndex === -1) return;

    const key = trimmed.slice(0, separatorIndex).trim().toLowerCase();
    const rawValue = trimmed.slice(separatorIndex + 1).trim();

    if (!rawValue) return;

    if (key === "title") {
      metadata.title = stripWrappingQuotes(rawValue);
    } else if (key === "slug") {
      metadata.slug = stripWrappingQuotes(rawValue);
    } else if (key === "summary") {
      metadata.summary = stripWrappingQuotes(rawValue);
    } else if (key === "description") {
      metadata.description = stripWrappingQuotes(rawValue);
    } else if (key === "date") {
      metadata.date = stripWrappingQuotes(rawValue);
    } else if (key === "tags") {
      metadata.tags = parseList(rawValue);
    } else if (key === "categories") {
      metadata.categories = parseList(rawValue);
    } else if (key === "readtime") {
      metadata.readTime = parseInteger(rawValue);
    }
  });

  return metadata;
};

export function parseMarkdownWithFrontMatter(rawMarkdown = "") {
  const raw = String(rawMarkdown);
  const withoutBom = raw.replace(/^\uFEFF/, "");

  if (!withoutBom.startsWith("---")) {
    return {
      metadata: {},
      content: withoutBom,
      hasFrontMatter: false,
    };
  }

  const normalized = withoutBom.replace(/\r\n?/g, "\n");
  const lines = normalized.split("\n");

  if (!FRONT_MATTER_OPEN_PATTERN.test(lines[0])) {
    return {
      metadata: {},
      content: withoutBom,
      hasFrontMatter: false,
    };
  }

  const closingIndex = lines.findIndex(
    (line, index) => index > 0 && FRONT_MATTER_DELIMITER_PATTERN.test(line),
  );

  if (closingIndex === -1) {
    return {
      metadata: {},
      content: withoutBom,
      hasFrontMatter: false,
    };
  }

  const frontMatter = lines.slice(1, closingIndex).join("\n");
  const content = lines.slice(closingIndex + 1).join("\n").replace(/^\n+/, "");

  return {
    metadata: parseFrontMatterBlock(frontMatter),
    content,
    hasFrontMatter: true,
  };
}

export function getMarkdownPreview(metadata = {}, excerpt = "", fallback = "") {
  if (metadata.summary) return metadata.summary;
  if (metadata.description) return metadata.description;
  if (excerpt) return `${excerpt}...`;
  return fallback;
}
